/**
 * Extract a user-facing error message from an Intervene / coreapi response.
 */
export function parseInterveneApiError(res, fallback = 'Request failed') {
  const data = res?.data?.data;
  if (typeof data === 'string' && data.trim()) {
    return data;
  }
  const generalError = data?.general_error;
  if (typeof generalError === 'string' && generalError.trim()) {
    return generalError;
  }
  if (generalError?.error?.message) {
    return generalError.error.message;
  }
  if (generalError?.message) {
    return generalError.message;
  }
  if (typeof res?.data?.message === 'string' && res.data.message.trim()) {
    return res.data.message;
  }
  return fallback;
}
